export const locales = ['vi'];

export const nonLyricsTypes = ['i', 'I', 'e'];

export const BASE_ORDER_CODE = process.env.ENVIRONMENT === 'local' ? 5_000 : 0;

export const SongPartText: Record<string, string> = {
	i: 'Intro',
	v: 'Verse',
	p: 'Pre-Chorus',
	c: 'Chorus',
	b: 'Bridge',
	t: 'Tag',
	I: 'Instrumental',
	e: 'Ending'
};

export const SongPartStyle: Record<string, string> = {
	i: '',
	v: '',
	p: 'italic',
	c: 'font-bold',
	b: 'font-bold italic',
	t: '',
	I: '',
	e: ''
};

export const initialChordsText = '';

export const NOT_APPLICABLE = 'N/A';

export const MIX_PANEL_EVENT = {
	HTTP_ERROR: 'HTTP_ERROR',
	HTTP_UNKNOWN_ERROR: 'HTTP_UNKNOWN_ERROR',
	HTTP_ERROR_500: 'HTTP_ERROR_500',
	HTTP_ERROR_404: 'HTTP_ERROR_404',
	HTTP_ERROR_400: 'HTTP_ERROR_400',
	HTTP_ERROR_401: 'HTTP_ERROR_401',

	CREATE_SONG: 'CREATE_SONG',
	UPDATE_SONG: 'UPDATE_SONG',
	DELETE_SONG: 'DELETE_SONG',

	CREATE_WORSHIP_SET: 'CREATE_WORSHIP_SET',
	UPDATE_WORSHIP_SET: 'UPDATE_WORSHIP_SET',
	DELETE_WORSHIP_SET: 'DELETE_WORSHIP_SET',

	FUNCTIONS_SUCCESSFUL: 'FUNCTIONS_SUCCESSFUL',
	FUNCTIONS_ERROR: 'FUNCTIONS_ERROR'
};

export const DEFAULT_FONT_SIZE = 15;
export const DEFAULT_EXPIRED_CACHE = 86400; // 1 day

export const DEFAULT_SONG_KEYWORDS = [
	'Phấn Hưng',
	'Dân Tộc',
	'Hiệp Một',
	'Truyền Giáo',
	'Yêu Thương',
	'Vui Mừng',
	'Bình An',
	'Dâng Hiến',
	'Trung Tín',
	'Giáng Sinh',
	'Thập Tự Giá',
	'Ân Điển',
	'Phục Sinh',
	'Ngợi Khen',
	'Cầu Nguyện',
	'Đức Thánh Linh',
	'Đức Tin',
	'Sự Sống',
	'Chúa Jêsus',
	'Phước Hạnh',
	'Kính Sợ',
	'Cứu Rỗi',
	'Thờ Phượng',
	'Biết Ơn',
	'Hy Vọng',
	'Đổi Mới',
	'Vương Quốc',
	'Vinh Hiển',
	'Chữa Lành',
	'Quyền Năng',
	'Hy Sinh',
	'An Ủi',
	'Vâng Lời',
	'Thánh Khiết',
	'Sự Nhân Từ',
	'Sự Biến Đổi',
	'Đời Sống Mới',
	'Sự Tươi Mới',
	'Giao Ước',
	'Tự Do',
	'Sự Tái Lâm',
	'Kinh Thánh',
	'Hội Thánh',
	'Đấng Chăn Dắt',
	'Đấng Đắc Thắng',
	'Lời Hứa',
	'Tái Sinh',
	'Tan Vỡ',
	'Chân Lý',
	'Đời Sống Cơ Đốc',
	'Thông Công'
];

export const metaKeywords =
	'Nissi, Nissi United, Tin Lành, Thánh Ca, hợp âm Thánh Ca, Nhạc Thánh, hợp âm Nhạc Thánh, lời bài hát Thánh Ca, tôn vinh Chúa, set thờ phượng, thanhcaviet, thanhcaviet.net, lời hợp âm, tra cứu hợp âm, hợp âm chuẩn';
